module.exports = __webpack_public_path__ + "media/images/version_merge/ddd_background-8aa053d61b5c4c5886d5b2459a2cc6d4.png";